import { FormControl as Input } from 'react-bootstrap'
import { ChangeEvent } from 'react'

interface IProps {
  label: string
  name: string
  isInvalid: boolean
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
  defaultValue?: string
  error?: string
  readOnly?: boolean
  isRequired?: boolean
}

export const FormFieldInput = ({
  label,
  isInvalid,
  name,
  handleChange,
  defaultValue,
  error,
  readOnly,
  isRequired
}: IProps) => (
  <div className="arbitration-field">
    <label className={`${isRequired ? 'required-field' : ''}`}>{label}</label>
    <div className="input-context">
      <Input
        name={name}
        isInvalid={isInvalid}
        onChange={handleChange}
        defaultValue={defaultValue}
        readOnly={readOnly ?? false}
      />
      {isInvalid && <div className="error-label">{error}</div>}
    </div>
  </div>
)
